import FormulaIcon from "../../../images/formula.png";

export function MathEditorButton({ setOpen }) {
  return (
    <img
      onClick={() => setOpen(true)}
      src={FormulaIcon}
      alt="formula"
      style={{
        width: "25px",
        height: "fit-content",
        margin: "auto",
        cursor: "pointer",
      }}
    />
  );
}
